import React from "react";
import loadable from "@loadable/component";
import { tw } from "@careinfo/tailwind";
import ExpenseNoteIcon from "../../Icons/ExpenseNoteIcon";

const ExpenseNoteComponent = loadable(
  () => import("../../components/ExpenseNote/ExpenseNote")
);
const ExpenseNote = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <ExpenseNoteIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Expense Note
        </span>
      </div>
      <ExpenseNoteComponent />
    </>
  );
};

export default ExpenseNote;
